<template>
    <div class="padding-10">
        <a-divider orientation="left">字典项目</a-divider>

        <div class="search-div">
            <div class="table-page-search-wrapper">
                <a-form layout="inline">
                    <a-row :gutter="12">
                        <a-col :md="6" :sm="24">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  label="类别">
                                <a-select  v-model="queryParam.selectId" :defaultValue="queryParam.defaultSelect"  @change="changeType">
                                    <a-select-option v-for="item in queryParam.select" :key="item.id" :value="item.content">{{item.content}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>

                        <a-col :md="6" :sm="24">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  label=" " :colon="false">
                             <span class="table-page-search-submitButtons">
                              <a-button type="primary" @click="initTable">查询</a-button>
                             </span>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </div>

        <div class="table-tools-right">
            <a-button-group >
                <a-button  @click="initTable"><i class="fa fa-refresh icon"></i>  刷新</a-button>
                <a-button type="primary" @click="add"><i class="fa fa-plus icon"></i>  新增</a-button>
            </a-button-group>
        </div>
        <a-table :loading="loading"
                 :columns="columns"
                 :dataSource="data"
                 bordered
                 @change="changeOrder"
                 :pagination="pagination"
        >
                   <span slot="id" slot-scope="text, record, index">
                        <template>
                            <span>{{index + 1}}</span>
                        </template>
                  </span>

            <span slot="option" slot-scope="text, record, index">
                        <template>
                            <div class="btn">
                                <span class="badge-success" @click="edit(record)">编辑</span>
                                <a-popconfirm
                                        title="真的要删除该字典项目吗？"
                                        @confirm="confirm(record)"
                                        okText="是"
                                        cancelText="否"
                                >
                                    <span class="badge-danger" >删除</span>
                                </a-popconfirm>
                            </div>
                        </template>
                  </span>
        </a-table>

        <a-modal title="字典项目" v-model="addModel.visible" @ok="handleOk" :maskClosable="false">
            <div class="search-div">
                <div class="table-page-search-wrapper">
                    <a-form :form="form" layout="inline">
                        <a-row :gutter="12">
                            <a-form-item label="类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-select v-decorator="['type', { rules: [{ required: true, validator: handleType }] }]">
                                    <a-select-option  v-for="item in staticParam.type" :key="item.id" :value="item.content">{{item.content}}</a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input v-decorator="['name', { rules: [{ required: true, whitespace: true, message: '名称不能为空' }] }]"/>
                            </a-form-item>
                            <a-form-item label="描述" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input v-decorator="['content']"/>
                            </a-form-item>
                        </a-row>
                    </a-form>
                </div>
            </div>
        </a-modal>

        <a-modal title="修改字典项目" v-model="editModel.visible" @ok="handleEditOk" :maskClosable="false">
            <div class="search-div">
                <div class="table-page-search-wrapper">
                    <a-form :form="editForm" layout="inline">
                        <a-row :gutter="12">
                            <a-form-item label="类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-select v-decorator="['type', { rules: [{ required: true, validator: handleType }] }]">
                                    <a-select-option  v-for="item in staticParam.type" :key="item.id" :value="item.content">{{item.content}}</a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input v-decorator="['name', { rules: [{ required: true, whitespace: true, message: '名称不能为空' }] }]"/>
                            </a-form-item>
                            <a-form-item label="描述" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 20px">
                                <a-input v-decorator="['content']"/>
                            </a-form-item>
                        </a-row>
                    </a-form>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
    import moment from "moment"
    import groupSelectList from "../components/common/groupSelectList";
    import stationSelectList from "../components/common/stationSelectList";

    const columns = [
        {
            title: 'id',
            key: 'id',
            dataIndex: 'id',
            sorter: true,
            scopedSlots: {customRender: "id"},
        },
        {
            title: '类别',
            key: 'dictContent',
            dataIndex: 'dictContent',
            sorter: true,
        },
        {
            title: '名称',
            key: 'name',
            dataIndex: 'name',
            sorter: true
        },
        {
            title: '内容',
            key: 'content',
            dataIndex: 'content',
            sorter: true
        },
        {
            title: '创建时间',
            key: 'created',
            dataIndex: 'created',
            sorter: true
        },
        {
            title: '操作',
            key: 'option',
            dataIndex: 'option',
            sorter: true,
            scopedSlots: {customRender: "option"},
            width: 150,
            fixed: 'right'
        }


    ];
    export default {
        name: "weatherStation",
        components:{
            groupSelectList,
            stationSelectList
        },
        data(){
            return {
                labelCol: {
                    span: 6
                },
                columns,
                data: [],
                form: this.$form.createForm(this),
                editForm: this.$form.createForm(this),
                queryParam:{
                    select: [],
                    selectId: "不限",
                    defaultSelect: "不限"
                },
                queryParams:{
                    sortName: 'id',
                    sortOrder: 'asc',
                    page: 1,
                    size: 10
                },
                order: {
                    ascend: 'asc',
                    descend: 'desc'
                },
                loading: false,
                pagination: {
                    total: 0,
                    current: 1,
                    // defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ['10','20','50','100']
                },
                staticParam:{
                    type:[]
                },
                addModel:{
                    visible: false
                },
                editModel:{
                    visible: false,
                    obj: null,
                    groupId: '',
                    station: '',
                    protocol: 'TCP',
                    vender: '阳光'
                },
                groupId: 0,
                stationId: 0,
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            async init(){
                await this.loadType();
                this.queryParam.select = this.staticParam.type;
                this.queryParam.select.push({id: 0, content: '不限'});
                await this.initTable();
            },
            async initTable(){
                this.loading = true;
                let queryResult = this.getTypeId(this.queryParam.selectId );
                let dictId = '';
                if(queryResult.flag){
                    dictId = queryResult.id;
                }
                let result = await this.$http.get(this.$baseURL.dictItemPage({dictId: dictId }, this.queryParams));
                console.log(result)
                this.data = result.list;
                this.pagination.current = result.pageNum;
                this.pagination.total = result.total;
                this.loading = false;
                console.log(this.pagination)
            },
            changeOrder(pagination, filters, sorter){
                console.log(pagination ,sorter)
                this.queryParams.page = pagination.current;
                this.queryParams.sortName = sorter.columnKey ? sorter.columnKey : 'id';
                this.queryParams.sortOrder = sorter.order ? this.order[sorter.order] : 'asc';
                this.initTable()
            },

            changeType(){
                this.initTable();
            },
            async add(){
                this.addModel.visible = true;
                await this.loadType();
                this.$nextTick(()=>{
                    this.form.setFieldsValue({
                        "name": '',
                        "type": '',
                        "content": ''
                    })
                })
            },

            handleOk(e){
                e.preventDefault();
                const { form: { validateFields }} = this;
                validateFields(["name","type","content"], { force: true }, (err, values) => {
                    if (!err) {
                        if (!err) {
                            let params = { ...values };
                            let result = this.getTypeId(params.type);
                            if(result.flag){
                                params.dictId = result.id;
                                this.addDictItem(params);
                            } else {
                                this.$Utils.showWarning({title: '未找到类别'})
                            }
                            //console.log(result)

                            //console.log(params)
                        }
                    }
                })
            },
            async addDictItem(obj){
                await this.$http.postJson(this.$baseURL.dictItemManage(), obj);
                this.$Utils.showSuccess({title: '添加成功'});
                this.addModel.visible = false;
                this.initTable();
            },
            /**********编辑**********/

            async edit(data){
                console.log(data);
                this.editModel.visible = true;
                this.editModel.obj = data;
                await this.loadType();
                this.$nextTick(()=>{
                    this.editForm.setFieldsValue({
                        'name': data.name,
                        "type": data.dictContent,
                        "content": data.content
                    })
                })

            },

            handleEditOk(e){
                e.preventDefault();
                const { editForm: { validateFields }} = this;
                validateFields(["name","type","content"], { force: true }, (err, values) => {
                    if (!err) {
                        let params = { ...values };
                        let result = this.getTypeId(params.type);
                        if(result.flag){
                            params.dictId = result.id;
                            this.eddDictItem(params);
                        } else {
                            this.$Utils.showWarning({title: '未找到类别'})
                        }

                        //console.log(params)
                    }
                })
            },
            async eddDictItem(obj){
                obj.id = this.editModel.obj.id;
                await this.$http.putJson(this.$baseURL.dictItemManage(), obj);
                this.$Utils.showSuccess({title: '修改成功'});
                this.editModel.visible = false;
                this.initTable();
            },
            /************删除*************/
            async confirm(data){
                console.log(data)
                await this.$http.deleteJson(this.$baseURL.dictItemById(data.id));
                this.$Utils.showSuccess({title: '删除成功'});
                this.initTable();
            },

            /**************自定义校验**************/
            handleType(rule,value, callback){
                if(value === undefined || value === null  || value.length === 0){
                    callback('类别不能为空，请选择')
                } else if(value === -1){
                    callback('类别不能为空，请先从后台添加')
                }
                callback()
            },
            getTypeId(name){
                let flag = false;
                let id = '';
                this.staticParam.type.forEach(item => {
                    if(item.content === name){
                        flag = true;
                        id = item.id;
                        return false;
                    }
                });
                return {
                    flag: flag,
                    id: id
                }
            },

            async loadType(){
                this.staticParam.type = await this.$http.get(this.$baseURL.dictList());
            }

        },
        computed:{
            wrapperCol(){
                return {span: 24 - this.labelCol.span};
            }
        }
    }
</script>

<style lang="less" scoped>

    .table-tools-right {
        display: flex;
        flex-direction: row-reverse;
        margin-bottom: 15px;
    }

    .icon{
        margin-right: 5px;
    }
    .btn {
        span{
            display: inline-block;
            padding: 3px 10px;
            margin-right: 5px;
            &:hover{
                cursor: pointer;
            }
        }
        .badge-success:hover {
            background: #1890ff;
        }

        .badge-danger:hover{
            background: #ed3543;
        }

    }
</style>
